import "./App.css";
import "./ofms.css";
import { BrowserRouter as Router, Route, Switch, useHistory,Redirect} from "react-router-dom";
import Footer from "./Footer/Footer";
import React from "react";
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import SpinnerReducer from "./Components/Reducer/SpinnerReducer";
import Loader from "./Components/CommonServices/Loader";
import GetTokenReducer from "./Components/Reducer/TokenDetailsformLogin";
import { useState} from "react";
import Login from "./Components/Login";
import LandingPage1 from "./LandingPage";
import Swal from "sweetalert2"; 
const reducer = combineReducers({
  spinner: SpinnerReducer,
  gettokenreducer: GetTokenReducer,
});
export const store = createStore(reducer, applyMiddleware(thunk));
const { dispatch } = store;
function App() {
  const [loggedIn, setLoggedIn] = useState();
  const history = useHistory();
  let token = "";
  function AdminGuardedRoute(user) {
    return function ({ component: Component, ...rest }) {
      return (
        <Route
          {...rest}
          render={(props) => (user ? <Component {...props} /> : "")}
        />
      );
    };
  }

  const Global_Constants = { hist: "" };

  const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
      <Route {...rest} render={props => {
        if (localStorage.getItem('token') !== null && localStorage.getItem('token') !== '' && localStorage.getItem('token') !== undefined) {
          return <Component  ></Component>;
        }
        else {
          Swal.fire({
            text: 'You have Successfully Logged Out',
            icon: 'success',
            confirmButtonText: 'Ok',
            confirmButtonClass: "swal-button--confirm"
          }).then(
              function () {
                  window.location.href = "/login"
              }
          );
        }
      }
      } />
    );
  };

  Global_Constants.history = history;
  return (
    <>
      <Provider store={store}>
        <Loader />
        <div className="App">
          <div className="main_section"> </div>
          <Router>
            <Switch>
              <Route path="/login"> <Login /> </Route>
              <Route exact path="/"> <Redirect to="/login" /> </Route> 
              <LandingPage1 PrivateRoute={PrivateRoute} />
              <Route path="*"> <Login /> </Route> 
            </Switch>
          </Router>
          <Footer /> 
        </div>
      </Provider> 
    </>
  );
}
export default App;
